var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ redLabel: _vm.redLabel === true}},[_vm._v(_vm._s(_vm.divisionRenderTextComputed))])
}
var staticRenderFns = []

export { render, staticRenderFns }